import React from 'react';

import { OpcIntegrationCard } from 'components/pages/IntegrationsPage/components/Integrations/components/ConnectedIntegrations/components/OpcIntegrationCard/OpcIntegrationCard';

import classes from './ConnectedIntegrations.module.scss';

export const ConnectedIntegrations = () => {
    return (
        <div className={classes.ConnectedIntegrations}>
            <div className={classes.title}>Connected Integrations</div>
            <div className={classes.cardsContainer}>
                <OpcIntegrationCard />
            </div>
        </div>
    );
};
